import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=523b93d1&scoped=true"
import script from "./ResultPage.vue?vue&type=script&lang=js"
export * from "./ResultPage.vue?vue&type=script&lang=js"
import style0 from "./ResultPage.vue?vue&type=style&index=0&id=523b93d1&prod&lang=less"
import style1 from "./ResultPage.vue?vue&type=style&index=1&id=523b93d1&prod&lang=less&scoped=true"
import style2 from "./ResultPage.vue?vue&type=style&index=2&id=523b93d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b93d1",
  null
  
)

export default component.exports